import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 300,
  },
});

class Location extends Component {
  render() {
    const {
      classes,
      name,
      values,
      errors,
      touched,
      handleBlur,
      handleChange,
      isSubmitting,
    } = this.props;

    return (
      <Grid container direction="column" className={classes.root}>
        <TextField
          name={name + "TypeOf"}
          select
          label="Type of home"
          className={classes.textField}
          disabled={isSubmitting}
          value={values[name + "TypeOf"]}
          onChange={handleChange}
          onBlur={handleBlur}
          helperText={touched[name + "TypeOf"] && errors[name + "TypeOf"]}
          error={touched[name + "TypeOf"] && !!errors[name + "TypeOf"]}
          margin="normal"
          variant="outlined"
        >
          <MenuItem value={"apt"}>Apartment / Condo</MenuItem>
          <MenuItem value={"house"}>House</MenuItem>
          <MenuItem value={"storage"}>Mini Storage</MenuItem>
        </TextField>

        {(values[name + "TypeOf"] === "apt" ||
          values[name + "TypeOf"] === "storage") && (
          <TextField
            name={name + "UnitNumber"}
            label="Unit number"
            className={classes.textField}
            disabled={isSubmitting}
            value={values[name + "UnitNumber"]}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={
              touched[name + "UnitNumber"] && errors[name + "UnitNumber"]
            }
            error={
              touched[name + "UnitNumber"] && !!errors[name + "UnitNumber"]
            }
            margin="normal"
            variant="outlined"
          />
        )}

        {values[name + "TypeOf"] === "house" && (
          <TextField
            name={name + "SqFt"}
            select
            label="Bedrooms"
            className={classes.textField}
            disabled={isSubmitting}
            value={values[name + "SqFt"]}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={touched[name + "SqFt"] && errors[name + "SqFt"]}
            error={touched[name + "SqFt"] && !!errors[name + "SqFt"]}
            margin="normal"
            variant="outlined"
          >
            <MenuItem value={"1b"}>1 bedroom</MenuItem>
            <MenuItem value={"2b"}>2 bedroom</MenuItem>
            <MenuItem value={"3b"}>3 bedroom</MenuItem>
            <MenuItem value={"4b"}>4 bedroom</MenuItem>
            <MenuItem value={"5b"}>5 bedroom</MenuItem>
            <MenuItem value={"6b"}>6 bedroom</MenuItem>
          </TextField>
        )}

        {values[name + "TypeOf"] === "apt" && (
          <TextField
            name={name + "SqFtApt"}
            select
            label="Bedrooms"
            className={classes.textField}
            disabled={isSubmitting}
            value={values[name + "SqFtApt"]}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={touched[name + "SqFtApt"] && errors[name + "SqFtApt"]}
            error={touched[name + "SqFtApt"] && !!errors[name + "SqFtApt"]}
            margin="normal"
            variant="outlined"
          >
            <MenuItem value={"loft"}>Loft</MenuItem>
            <MenuItem value={"1b"}>1 bedroom</MenuItem>
            <MenuItem value={"2b"}>2 bedroom</MenuItem>
            <MenuItem value={"3b"}>3 bedroom</MenuItem>
            <MenuItem value={"4b"}>4 bedroom</MenuItem>
          </TextField>
        )}

        {values[name + "TypeOf"] === "storage" && (
          <TextField
            name={name + "SqFtMiniStorage"}
            select
            label="Size"
            className={classes.textField}
            disabled={isSubmitting}
            value={values[name + "SqFtMiniStorage"]}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={
              touched[name + "SqFtMiniStorage"] &&
              errors[name + "SqFtMiniStorage"]
            }
            error={
              touched[name + "SqFtMiniStorage"] &&
              !!errors[name + "SqFtMiniStorage"]
            }
            margin="normal"
            variant="outlined"
          >
            <MenuItem value={"25"}>5 x 5</MenuItem>
            <MenuItem value={"50"}>5 x 10</MenuItem>
            <MenuItem value={"100"}>10 x 10</MenuItem>
            <MenuItem value={"150"}>10 x 15</MenuItem>
            <MenuItem value={"200"}>10 x 20</MenuItem>
            <MenuItem value={"300"}>10 x 30</MenuItem>
          </TextField>
        )}

        {values[name + "TypeOf"] === "apt" && (
          <TextField
            name={name + "Floor"}
            label="What floor is it on?"
            type="number"
            className={classes.textField}
            disabled={isSubmitting}
            value={values[name + "Floor"]}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={touched[name + "Floor"] && errors[name + "Floor"]}
            error={touched[name + "Floor"] && !!errors[name + "Floor"]}
            margin="normal"
            variant="outlined"
          />
        )}

        {values[name + "TypeOf"] === "house" && (
          <TextField
            name={name + "NumFloors"}
            select
            label="Number of floors"
            className={classes.textField}
            disabled={isSubmitting}
            value={values[name + "NumFloors"]}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={
              touched[name + "NumFloors"] && errors[name + "NumFloors"]
            }
            error={touched[name + "NumFloors"] && !!errors[name + "NumFloors"]}
            margin="normal"
            variant="outlined"
          >
            <MenuItem value={1}>1 floor</MenuItem>
            <MenuItem value={2}>2 floors</MenuItem>
            <MenuItem value={3}>3 floors</MenuItem>
            <MenuItem value={4}>4 floors</MenuItem>
          </TextField>
        )}

        {values[name + "TypeOf"] === "apt" && (
          <TextField
            name={name + "Elevator"}
            label="Is there an elevator?"
            select
            className={classes.textField}
            disabled={isSubmitting}
            value={values[name + "Elevator"]}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={touched[name + "Elevator"] && errors[name + "Elevator"]}
            error={touched[name + "Elevator"] && !!errors[name + "Elevator"]}
            margin="normal"
            variant="outlined"
          >
            <MenuItem value={"1"}>Yes</MenuItem>
            <MenuItem value={"0"}>No</MenuItem>
          </TextField>
        )}

        {name == "origin" &&
          (values["originTypeOf"] === "apt" ||
            values["originTypeOf"] === "house") && (
            <TextField
              name={"itemsIn"}
              label="Items in..."
              select
              className={classes.textField}
              disabled={isSubmitting}
              value={values["itemsIn"]}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={touched["itemsIn"] && errors["itemsIn"]}
              error={touched["itemsIn"] && !!errors["itemsIn"]}
              margin="normal"
              variant="outlined"
            >
              <MenuItem value={"garage"}>Garage</MenuItem>
              <MenuItem value={"basement"}>Basement</MenuItem>
              <MenuItem value={"both"}>Garage &amp; Basement</MenuItem>
              <MenuItem value={"na"}>N/A</MenuItem>
            </TextField>
          )}
      </Grid>
    );
  }
}

Location.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Location);
